import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Responseloader from "./ResponseLoader";
import { GetIp } from "./Get_ip";
import "./myReactSelect.css";
import { Col, Row, Container, FormGroup, Input, Label } from "reactstrap";
import "./paymentPrint.css";
import "./baseForms.css";
import axios from "axios";
import { baseurl } from "../../../baseurl";

let companyId = localStorage.getItem("companyId");
let username = localStorage.getItem("username");
var token = localStorage.getItem("token");

export default function RefundCustPrint(props) {
  console.log("props :>> ", props);
  const printDataProp = props?.location?.state?.PrintData;
  console.log("printDataProp", printDataProp);
  const [table, setTable] = useState({
    OverViewDataTable: [],
  });
  const [loadingResponse, setLoadingResponse] = useState(false);
  const [printData, setPrintData] = useState([]);
  const [footerData, setFooterData] = useState([]);
  const [noOfRows, setNoOfRows] = useState([]);
  const [nextPrintPage, setNextPrintPage] = useState(false);
  const [goBackUrl, setGoBackUrl] = useState([]);

  useEffect(() => {
    const id = 11;
    const url = props.location.state?.goBackUrl;
    setGoBackUrl(url);
    if (id) {
      getDataWithId(id);
    }
  }, []);
  const dynamicTopDesc = () => {
    return (
      <Row className="my-1 mt-1 ">
        <Container>
          <Row>
            <Col md="6">
              {" "}
              <h5>
                InvBookDesc:{" "}
                <span className="h5 text-muted">
                  {printData[0]?.inv_book_desc}
                </span>
              </h5>
            </Col>
            <Col md="6">
              {" "}
              <h5 className="voucherNo" style={{ textAlign: "right" }}>
                Voucher No:{" "}
                <span className="h5 text-muted">{printData[0]?.voucherNo}</span>
              </h5>
            </Col>
            <Col md="6">
              {" "}
              <h5 className="vendor">
                Customer:{" "}
                <span className="h5 text-muted">
                  {printData[0]?.customerName}
                </span>
              </h5>
            </Col>
            <Col md="6">
              <h5 className="date" style={{ textAlign: "right" }}>
                Pay Date :{" "}
                <span className="h5 text-muted">{printData[0]?.date}</span>
              </h5>
            </Col>

            <Col md="6">
              {" "}
              <h5 className="BCE">
                Bank/cash:{" "}
                <span className="h5 text-muted">{printData[0]?.BANK_NAME}</span>
              </h5>
            </Col>
            <Col md="6">
              {" "}
              <h5 className="paidAmount" style={{ textAlign: "right" }}>
                Receipt Amount :{" "}
                <span className="h5 text-muted">
                  {printData[0]?.paid_amount}
                </span>
              </h5>
            </Col>
            <Col md="12" style={{ marginTop: "-1.7rem" }}>
              <h5 className="unAppliedAmt" style={{ textAlign: "center" }}>
                Unapplied Amount :{" "}
                <span className="h5 text-muted">
                  {printData[0]?.unAppliedAmount}
                </span>
              </h5>
            </Col>
          </Row>
        </Container>
      </Row>
    );
  };
  const getDataWithId = (id) => {
    setLoadingResponse(true);
    axios
      .post(
        `${baseurl}/moneyIn/getSomOnePaidMeData`,
        {
          receiptMtId: id,

          username: username,
          companyId: companyId,
        },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((res) => {
        let response = res.data.data;
        getFooterDataWithId(response[0]?.inv_book_id);

        // Calculate the sum of paid_amount values
        const sumOfPaidAmount = response.reduce(
          (total, item) => total + item.paid_amount,
          0
        );
        const unAppliedAmount = response[0]?.masterAmount - sumOfPaidAmount;

        let label;
        if (response.page_size === "F") {
          label = "Full";
        } else {
          label = "Half";
        }
        const formValues = [];
        for (let i = 0; i < response.length; i++) {
          formValues.push({
            inv_book_desc: response[i].inv_book_desc,
            customerName: response[i].customerName,
            BANK_NAME: response[i].BANK_NAME,
            docNo: response[i].docNo,
            voucherNo: response[i].RECEIPT_NO,
            date: response[i].DATE,
            invoiceDate: response[i].invoiceDate,
            invBookDesc: response[i].INV_BOOK_DESC,
            paid_amount: response[i].paid_amount,
            unAppliedAmount: unAppliedAmount >= 0 ? unAppliedAmount : 0,
            purch_date: response[i].purch_date,
          });
        }
        // for (let i = 0; i < 30; i++) {
        //   formValues.push({
        //     inv_book_desc: "Hello",
        //     customerName: "Hello",
        //     BANK_NAME: "Hello",
        //     docNo: i + 1,
        //     date: "Hello",
        //     invBookDesc: "Hello",
        //     paid_amount: "Hello",
        //     unAppliedAmount: "Hello",
        //     purch_date: "Hello",
        //   });
        // }
        let rowArray = [];
        const numberOfRows = Math.ceil(formValues.length / 3);
        for (let index = 0; index < numberOfRows; index++) {
          rowArray.push(index);
        }
        if (formValues.length > 18) {
          setNextPrintPage(true);
        }
        setNoOfRows(rowArray);
        setPrintData(formValues);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(function () {
        setLoadingResponse(false);
      });
  };
  const getFooterDataWithId = (id) => {
    setLoadingResponse(true);
    axios
      .post(
        `${baseurl}/masterData/getDocFooterSetupId`,
        { id: 1, companyId: companyId, username: username },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((res) => {
        let response = res.data.data[0];
        let label;
        if (response.page_size === "F") {
          label = "Full";
        } else {
          label = "Half";
        }
        const formValues = [];

        if (response.desc1 !== " ") {
          formValues.push({
            desc: response.desc1,
            enteredBy: response.Ent_by_1,
          });
        }
        if (response.desc_2 !== " ") {
          formValues.push({
            desc: response.desc_2,
            enteredBy: response.Ent_by_2,
          });
        }
        if (response.desc_3 !== " ") {
          formValues.push({
            desc: response.desc_3,
            enteredBy: response.Ent_by_3,
          });
        }
        if (response.desc_4 !== " ") {
          formValues.push({
            desc: response.desc_4,
            enteredBy: response.Ent_by_4,
          });
        }
        if (response.desc_5 !== " ") {
          formValues.push({
            desc: response.desc_5,
            enteredBy: response.Ent_by_5,
          });
        }
        if (response.desc_6 !== " ") {
          formValues.push({
            desc: response.desc_6,
            enteredBy: response.Ent_by_6,
          });
        }
        setFooterData(formValues);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(function () {
        setLoadingResponse(false);
      });
  };

  const getUserIp = async function () {
    let res = await GetIp();
    console.log(res);
    return {
      userIp: res.ip,
      userCountry: res.country,
    };
  };

  return (
    <>
      {loadingResponse ? (
        <Responseloader />
      ) : (
        <div id="pdfContent" className="pdfContentCustPrint">
          <Row className="app-body-Invoice bg-white rounded-lg ">
            <Col xs="12" className="mb-5">
              <div id="pdfContent">
                <br></br>
                <br></br>
                <Container>
                  <Row className=" ">
                    <Col md="6">
                      <h3>{localStorage.getItem("companyName")}</h3>
                    </Col>

                    <Col md="6">
                      <div style={{ textAlign: "end" }}>
                        <button
                          className="btn btn-primary mx-2 btn-sm print-half-size"
                          id="printPageButton"
                          onClick={() => {
                            window.print();
                          }}
                        >
                          Print to PDF!
                        </button>
                        <Link to="/SaleRefundOverview">
                          <button
                            className="btn btn-primary m-1  btn-sm"
                            id="printPageButton"
                            onClick={() => {
                              // this.goBackToInvoice();
                            }}
                          >
                            Back
                          </button>
                        </Link>
                      </div>
                    </Col>
                  </Row>
                </Container>

                {/* {dynamicTopDesc()} */}
                <Container className="">
                  <Row>
                    <div className="col-md-2">
                      <Label style={{ fontWeight: "bold" }}>Voucher No:</Label>
                      <Input
                        style={{ border: "1px solid rgb(167, 164, 164)" }}
                        value={printDataProp?.invoice_doc_no}
                        //   onCh/ange={inputEvent}
                        required
                        name="itemSubCategoryDesc"
                        id="itemSubCategoryDesc"
                        isClearable
                        disabled
                      />
                    </div>
                    <div className="col-md-7"></div>
                    <div className="col-md-3">
                      <Label style={{ fontWeight: "bold" }}>Refund Date:</Label>
                      <Input
                        style={{ border: "1px solid rgb(167, 164, 164)" }}
                        value={printDataProp?.inv_doc_date}
                        //   onChange={inputEvent}
                        required
                        name="itemSubCategoryDesc"
                        id="itemSubCategoryDesc"
                        isClearable
                        disabled
                      />
                    </div>
                    <div className="col-md-12">
                      <Label style={{ fontWeight: "bold" }}>Customer:</Label>
                      <Input
                        style={{ border: "1px solid rgb(167, 164, 164)" }}
                        value={printDataProp?.cust_name}
                        //   onChange={inputEvent}
                        required
                        name="itemSubCategoryDesc"
                        id="itemSubCategoryDesc"
                        isClearable
                        disabled
                      />
                    </div>
                    {/* <div className="col-md-12">
                      <Label style={{ fontWeight: "bold" }}>Bank/Cash:</Label>
                      <Input
                        style={{ border: "1px solid rgb(167, 164, 164)" }}
                        //   value={data.itemSubCategoryDesc}
                        //   onChange={inputEvent}
                        required
                        name="itemSubCategoryDesc"
                        id="itemSubCategoryDesc"
                        isClearable
                      />
                    </div> */}
                    <div className="col-md-2">
                      <Label style={{ fontWeight: "bold" }}>
                        Sale Return No :
                      </Label>
                      <Input
                        style={{ border: "1px solid rgb(167, 164, 164)" }}
                        value={printDataProp?.refund_doc_no}
                        //   onChange={inputEvent}
                        required
                        name="itemSubCategoryDesc"
                        id="itemSubCategoryDesc"
                        isClearable
                        disabled
                      />
                    </div>
                    <div className="col-md-7"></div>
                    <div className="col-md-3">
                      <Label style={{ fontWeight: "bold" }}>
                        Sale Return Date :
                      </Label>
                      <Input
                        style={{ border: "1px solid rgb(167, 164, 164)" }}
                        value={printDataProp?.refund_doc_date}
                        //   onChange={inputEvent}
                        required
                        name="itemSubCategoryDesc"
                        id="itemSubCategoryDesc"
                        isClearable
                        disabled
                      />
                    </div>
                    <div className="col-md-4">
                      <Label style={{ fontWeight: "bold" }}>
                        Sale Return Amt :
                      </Label>
                      <Input
                        style={{ border: "1px solid rgb(167, 164, 164)" }}
                        value={printDataProp?.tc_amt_with_st_disc}
                        //   onChange={inputEvent}
                        required
                        name="itemSubCategoryDesc"
                        id="itemSubCategoryDesc"
                        isClearable
                        disabled
                      />
                    </div>
                    <div className="col-md-4"></div>
                    <div className="col-md-4">
                      <Label style={{ fontWeight: "bold" }}>Refund Amt:</Label>
                      <Input
                        style={{ border: "1px solid rgb(167, 164, 164)" }}
                        value={printDataProp?.amount}
                        //   onChange={inputEvent}
                        required
                        name="itemSubCategoryDesc"
                        id="itemSubCategoryDesc"
                        disabled
                        isClearable
                      />
                    </div>
                  </Row>
                  {/* <table className="my-doubleTable">
                    <thead>
                      <tr>
                        {[0, 1, 2].map((colIndex) => (
                          <React.Fragment key={colIndex}>
                            <th
                              colSpan="2"
                              style={{
                                border: "1px solid black",
                                textAlign: "center",
                              }}
                            >
                              Invoice
                            </th>
                            <th
                              colSpan="1"
                              style={{
                                border: "1px solid black",
                                textAlign: "center",
                              }}
                            >
                              Receipt
                            </th>
                          </React.Fragment>
                        ))}
                      </tr>
                      <tr>
                        {[0, 1, 2].map((colIndex) => (
                          <React.Fragment key={colIndex}>
                            <th
                              style={{
                                border: "1px solid black",
                                width: "100px",
                                backgroundColor: "white",
                              }}
                            >
                              No.
                            </th>
                            <th
                              style={{
                                border: "1px solid black",
                                backgroundColor: "white",
                              }}
                            >
                              Date
                            </th>
                            <th
                              style={{
                                border: "1px solid black",
                                borderTop: "none",
                                textAlign: "center",
                                backgroundColor: "white",
                              }}
                            >
                              Amount
                            </th>
                          </React.Fragment>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {console.log("setNoOfRows :>> ", noOfRows)}
                      {noOfRows.map((row, rowIndex) => (
                        <tr key={rowIndex}>
                          {[0, 1, 2].map((colIndex) => {
                            const dataIndex = rowIndex * 3 + colIndex;
                            const currentRow = printData[dataIndex];

                            return (
                              <React.Fragment key={colIndex}>
                                <td style={{ border: "1px solid black" }}>
                                  {currentRow?.docNo}
                                </td>
                                <td style={{ border: "1px solid black" }}>
                                  {currentRow?.invoiceDate}
                                </td>
                                <td
                                  style={{
                                    textAlign: "right",
                                    border: "1px solid black",
                                  }}
                                >
                                  {currentRow?.paid_amount
                                    ? new Intl.NumberFormat("en-US", {
                                        style: "currency",
                                        currency: "USD",
                                      }).format(currentRow?.paid_amount)
                                    : null}
                                </td>
                              </React.Fragment>
                            );
                          })}
                        </tr>
                      ))}
                    </tbody>
                  </table> */}
                </Container>

                <Container
                  className={`${nextPrintPage ? "footerNewPage" : "footer"}`}
                >
                  <Row
                    className=""
                    style={{ textAlign: "center", marginTop: "5rem" }}
                  >
                    {footerData.map((row) => (
                      <Col
                        lg="4"
                        md="4"
                        sm="4"
                        className="px-5"
                        style={{
                          marginBottom: "3rem",
                          marginTop: row.enteredBy != 1 ? "0" : "0",
                        }}
                      >
                        <h5> {row.enteredBy ? printData[0]?.name : "  "}</h5>
                        <hr
                          style={{
                            border: "1px solid ",
                            borderColor: "E4E5E6",
                            margin: "revert",
                          }}
                        />
                        <h4 key={row.id}>{row.desc}</h4>
                      </Col>
                    ))}
                  </Row>
                </Container>
              </div>
            </Col>
          </Row>
        </div>
      )}
    </>
  );
}
